import Hero from '../components/Hero';
import FaixaUrgencia from '../components/FaixaUrgencia';
import Sobre from '../components/Sobre';
import Areas from '../components/Areas';
import Atendimento from '../components/Atendimento';
import Duvidas from '../components/Duvidas';
import Contato from '../components/Contato';

export default function Home() {
  return (
    <>
      <Hero />
      <FaixaUrgencia />
      <Sobre />
      <Areas />
      <Atendimento />
      <Duvidas />
      <Contato />
    </>
  );
}
